import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"

import { formatDate, formatMoney } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

// border-collapse схлопывает границы к таблице, поэтому у sticky-строки они не едут вместе с ней — рисуем тенью
const footCellStyle = {
	position: 'sticky',
	bottom: 0,
	background: 'var(--dark-surface, #fff)',
	borderTop: 0,
	borderBottom: 0,
	boxShadow: 'inset 0 1px 0 #dee2e6, inset 0 -1px 0 #dee2e6',
}

function getPreviousMonthDate() {
	const d = new Date()
	d.setDate(1)
	d.setMonth(d.getMonth() - 1)
	d.setHours(0, 0, 0, 0)
	return d
}

function ModalPosChequeStats({ show, onHide, posItem, apiBase }) {
	const { t } = useTranslation()

	const [monthFilter, setMonthFilter] = useState(getPreviousMonthDate)
	const [stats, setStats] = useState(null)

	async function loadStats(posId, monthDate) {
		if (!posId || !apiBase || !monthDate) return

		const response = await GET(`${apiBase}/${posId}/cheque-stats`, {
			year: monthDate.getFullYear(),
			month: monthDate.getMonth() + 1,
		}, { loader: true })
		if (httpOk(response)) {
			setStats(response.data)
		}
	}

	function handleMonthChange(date) {
		if (!date) return
		setMonthFilter(date)
		if (posItem?.id) {
			loadStats(posItem.id, date)
		}
	}

	useEffect(() => {
		if (show && posItem?.id) {
			const prevMonth = getPreviousMonthDate()
			setMonthFilter(prevMonth)
			setStats(null)
			loadStats(posItem.id, prevMonth)
		}
		if (!show) {
			setStats(null)
		}
	}, [show, posItem?.id]) // eslint-disable-line react-hooks/exhaustive-deps

	const titlePos = posItem?.name
		? `#${posItem.id} ${posItem.name}`
		: (posItem?.id ? `#${posItem.id}` : '')

	return (
		<Modal show={show} animation={false} centered
			dialogClassName="update-modal-width"
			onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('last_cheque')}{titlePos ? ` — ${titlePos}` : ''}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="form-group">
					<label>{t('date')}</label>
					<div className="calendar-input">
						<DatePicker
							withPortal
							showMonthYearPicker
							showFullMonthYearPicker
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
							className="form-control"
							dateFormat="MM.yyyy"
							placeholderText="Месяц / год"
							selected={monthFilter}
							maxDate={new Date()}
							onChange={handleMonthChange}
						/>
						<i className="uil uil-calendar-alt"></i>
					</div>
					<div className="text-muted mt-1" style={{ fontSize: 13 }}>
						{stats?.start_date && stats?.end_date
							? `${formatDate(stats.start_date)} — ${formatDate(stats.end_date)}`
							: null
						}
						{stats != null &&
							<span className="ms-2">
								· {t('total')}: <b>{stats.total ?? 0}</b>
								<span className="ms-2">· {t('amount')}: <b>{formatMoney(stats.total_amount ?? 0)}</b></span>
							</span>
						}
					</div>
				</div>

				<div className="table-responsive" style={{ maxHeight: 420, overflowY: 'auto' }}>
					<table className="table table-bordered mb-0">
						<thead style={{ position: 'sticky', top: 0, background: 'var(--dark-surface, #fff)' }}>
							<tr>
								<th style={{ width: 40 }} className="text-center">#</th>
								<th className="text-center">{t('date')}</th>
								<th className="text-end">{t('cheques')}</th>
								<th className="text-end">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{(stats?.days ?? []).map((item, index) => (
								<tr key={item.day}>
									<td className="text-center">{index + 1}</td>
									<td className="text-center">{formatDate(item.day)}</td>
									<td className={`text-end ${item.count ? 'fw-semibold' : 'text-muted'}`}>
										{item.count}
									</td>
									<td className={`text-end ${item.count ? 'fw-semibold' : 'text-muted'}`}>
										{formatMoney(item.amount ?? 0)}
									</td>
								</tr>
							))}
							{(!stats?.days || stats.days.length === 0) &&
								<tr>
									<td colSpan={4} className="text-center text-muted">
										{t('list_empty')}
									</td>
								</tr>
							}
						</tbody>
						{!!(stats?.days?.length) &&
							<tfoot>
								<tr>
									<td colSpan={2} className="text-end fw-bold" style={footCellStyle}>{t('total')}</td>
									<td className="text-end fw-bold" style={footCellStyle}>{stats.total ?? 0}</td>
									<td className="text-end fw-bold" style={footCellStyle}>{formatMoney(stats.total_amount ?? 0)}</td>
								</tr>
							</tfoot>
						}
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ModalPosChequeStats
